/* CC Shop by Category — campaigns 85602806 + 30607088 */
(function () {
  var sliders = {};
  var timers  = {};

  function initSlider(section) {
    var id          = section.getAttribute('data-section-id');
    var autoplay    = section.getAttribute('data-autoplay') === 'true';
    var autoplayMs  = parseInt(section.getAttribute('data-autoplay-speed'), 10);
    var itemsMobile = parseInt(section.getAttribute('data-items-mobile'), 10);
    var itemsTablet = parseInt(section.getAttribute('data-items-tablet'), 10);
    var itemsDesktop= parseInt(section.getAttribute('data-items-desktop'), 10);

    if (sliders[id]) { try { sliders[id].destroy(true); } catch (e) {} sliders[id] = null; }
    if (timers[id])  { clearInterval(timers[id]); timers[id] = null; }

    sliders[id] = new Siema({
      selector: '#cc-sbc-track-' + id,
      perPage : { 300: 1, 375: itemsMobile, 500: itemsTablet, 1024: itemsDesktop },
      loop    : true,
      duration: 400,
      easing  : 'ease-out'
    });

    if (autoplay) timers[id] = setInterval(function () { sliders[id].next(); }, autoplayMs);

    var prev = document.getElementById('cc-sbc-prev-' + id);
    var next = document.getElementById('cc-sbc-next-' + id);
    if (prev) prev.onclick = function () { sliders[id].prev(); };
    if (next) next.onclick = function () { sliders[id].next(); };
  }

  function loadSiema(cb) {
    if (typeof Siema !== 'undefined') { cb(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/siema@1.5.1/dist/siema.min.js';
    s.onload = cb;
    document.head.appendChild(s);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="shop-by-category"]').forEach(function (el) { initSlider(el); });
  }

  loadSiema(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { loadSiema(initAll); }, 300);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = document.querySelector('[data-section-id="' + e.detail.sectionId + '"][data-section-type="shop-by-category"]');
    if (section) loadSiema(function () { initSlider(section); });
  });

  document.addEventListener('shopify:block:select', function (e) {
    var id = e.detail.sectionId;
    if (timers[id]) { clearInterval(timers[id]); timers[id] = null; }
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var id = e.detail.sectionId;
    var section = document.querySelector('[data-section-id="' + id + '"][data-section-type="shop-by-category"]');
    if (!section) return;
    var autoplay   = section.getAttribute('data-autoplay') === 'true';
    var autoplayMs = parseInt(section.getAttribute('data-autoplay-speed'), 10);
    if (autoplay && sliders[id] && !timers[id]) timers[id] = setInterval(function () { sliders[id].next(); }, autoplayMs);
  });
})();
